import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getOrderGeneratorsFieldsWorksStaffPayments: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].GET_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS,
	},
	getOrderGeneratorsFieldsWorksStaffPayment: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].GET_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT,
	},
	createOrderGeneratorsFieldsWorksStaffPayment: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT,
	},
	putOrderGeneratorsFieldsWorksStaffPayment: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].PUT_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT,
	},
	patchOrderGeneratorsFieldsWorksStaffPayment: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT,
	},
	deleteOrderGeneratorsFieldsWorksStaffPayment: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT,
	},
}
